export var SET_SEO_DATA = 'SET_SEO_DATA';